export default {"src":"/_next/static/image/public/images/ic_original.71fd490fe9fda700ac2a410d710d2317.svg","height":33,"width":53};